
$(document).ready(function () {
    let sendCoinLoading = false;
    let email = cookie.getcookie('userInfoData') ? JSON.parse(cookie.getcookie('userInfoData')).email : null;


    getAjax(_url.getPayMessageList, {}).then(res => {
        if (res.data) {
            res.data.forEach((itm, ind) => {
                $('.purchase_item').eq(ind).attr('id', itm.id);
                $('.purchase_item').eq(ind).find('.purchase_num').html(itm.score);
                $('.purchase_item').eq(ind).find('.itemPrice').html('$' + itm.pricing);
            })
        }
    });
    $('.purchase_item .itemPrice').click(async function () {
        if (!window.isLoggedIn) {
            addNoLogin();
            return;
        }
        var that = $(this).parent('.purchase_item');
        // 禁用按钮或阻止重复点击
        if (that.hasClass('loading')) {
            return; // 如果按钮已经在加载中，则忽略点击
        }
        that.addClass('loading'); // 添加 loading 类以标记按钮为禁用状态
        let countryCode = await getCountryCode();
        getAjax(_url.getPayUrl, {
            payType: 'UseePayTask', planid: that.attr('id'), email: email, billingCountry: countryCode, url: `${location.href}?getresult=2`
        }).then(res => {
            if (res.code != 200) {
                that.removeClass('loading');
            } else {
                setTimeout(() => {
                    that.removeClass('loading');
                }, 5000);
            }

            switch (res.code) {
                case 200:
                    location.href = res.data.data.payParams.payUrl;
                    break;
                case 7005:
                    error(i18n[lang].pricing_showToast_10);
                    break;
                case 7006:
                    error(i18n[lang].pricing_showToast_11);
                    break;
                case 7007:
                    error(i18n[lang].pricing_showToast_12);
                    break;
                case 7008:
                    error(i18n[lang].pricing_showToast_11);
                    break;
                case 7009:
                    error(i18n[lang].pricing_showToast_13);
                    break;
                case 7010:
                    error(i18n[lang].pricing_showToast_14)
                    break;
            }
        })
    });

    $('.profile_send_coin').click(function () {
        if (!window.isLoggedIn) {
            addNoLogin();
            return;
        }
        let myCoinNum = cookie.getcookie('userInfoData') ? JSON.parse(cookie.getcookie('userInfoData')).score : 0;
        window.location.href.indexOf('profile') > -1 ? manage('SendTips_Profile_Click') : manage('SendTips_Character_Click');
        $('.my-coin .num').text(myCoinNum);
        $('.send-coin-mask').css('display', 'block')
    });
    $('.select-coin-item').click(function () {
        $('.select-coin-item').removeClass('active');
        $(this).addClass('active');
        let num = $(this).attr('data-coin-num')
        $('#sendCoinNum').val(num);

    });

    $('#sendCoinNum').on('input', function () {
        $('.select-coin-item').removeClass('active');

    });
    $('.close-icon').click(function () {
        $('.send-coin-mask').hide()

    });
    $('.get-coins-btn').click(function () {
        manage('SendTips_PopUp_GetCoins')
        $('.purchaseMask').addClass('active');
    })
    $('.purchaseMask .close').on('click', function () {
        $('.purchaseMask').removeClass('active');
    });
    $('.send-coin-btn').click(function () {
        manage('SendTips_PopUp_Send')
        let coinNum = $('#sendCoinNum').val();
        let score = parseInt(coinNum, 10);
        let reward_uid = window.location.href.indexOf('profile') > -1 ? getOpenid() : other_openid;
        console.log(score, 'scorescore');
        if (!coinNum || score == 0) {
            return false
        }
        if (sendCoinLoading) {
            return false
        }
        sendCoinLoading = true;
        getAjax(_url.userScoreReward, { score, reward_uid }).then(res => {
            if (res.code == 200) {

                let userInfoData = JSON.parse(cookie.getcookie('userInfoData'))
                userInfoData.score = res.data.score
                cookie.setcookie('userInfoData', JSON.stringify(userInfoData), 90)
                success(i18n[lang].coins_sent_successfully)
                // $('.my-coin .num').text(res.data.score);
                $('.send-coin-mask').hide()
                sendCoinLoading = false;
            } else if (res.code == 203) {
                $('.purchaseMask').addClass('active');
                error(i18n[lang].coins_not_enough);
                sendCoinLoading = false;
            } else if (res.code == 201) {
                error(i18n[lang].coins_eligible_receive);
                sendCoinLoading = false;
            } else if (res.code == 202) {
                error(i18n[lang].coins_reached_limit);
                sendCoinLoading = false;
            } else {
                error(i18n[lang].public_Network_error);
                sendCoinLoading = false;
            }
        })
    });


    //UseePay 支付返回状态提示
    if (window.location.search.indexOf('?getresult') > -1) {
        getAjax('/api/getUseePayResult', { getresult: 2 }).then(res => {
            if (res.code == 200) {
                let items = [
                    {
                        item_id: res.data.payOrderId,
                        item_name: res.data.name,
                        price: res.data.amount,
                        quantity: 1
                    }
                ]
                let impactItems = [
                    {
                        subTotal: res.data.amount,
                        category: res.data.name,
                        sku:res.data.payOrderId,
                        quantity: 1,
                        name: res.data.name
                    },
                ];
                impactReportPrice(res.data.mchOrderNo,res.data.currency,impactItems)
                showToast(i18n[lang].public_showToast_Success, i18n[lang].public_showToast_1, '/images/toast/icon_su.svg');
                reportTransaction(res.data.mchOrderNo, res.data.amount, '0', '0', res.data.currency, items)
            } else if (res.code == 7011) {
                showToast(i18n[lang].public_showToast_Warning, i18n[lang].public_showToast_2, '/images/toast/icon-warning.svg', i18n[lang].public_showToast_4);
            } else if (res.code == 7013) {
                showToast(i18n[lang].public_showToast_Error, i18n[lang].public_showToast_3, '/images/toast/icon_dialogue.svg');
            }
        })
    };

})

async function getCountryCode() {
    try {
        const response = await fetch('https://ipinfo.io/json?token=' + IPToken);
        const data = await response.json();
        return data.country;
    } catch (error) {
        console.error('Error fetching country code:', error);
    }
}